module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"important_notice":"Important Notice","action":"Action required for merchants using Yezza Pay","check":"Check now"},"ms":{"important_notice":"Important Notice","action":"Action required for merchants using Yezza Pay","check":"Check now"},"id":{"important_notice":"Catatan Penting","action":"Aksi yang diperlukan untuk pelanggan yang menggunakan Yezza Pay","check":"Cek sekarang"}}')
  delete Component.options._Ctor
}
